import { CheckCircle, XCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { withErrorCode } from '@/lib/errors'

interface SuccessData {
  purchaserName: string
  ticketTypeName: string
}

interface Props {
  state: 'success' | 'error'
  result: SuccessData | null
  errorMsg: string | null
  onReset: () => void
}

export function CheckInResult({ state, result, errorMsg, onReset }: Props) {
  return (
    <div
      className={`rounded-xl border-2 p-6 text-center space-y-4 ${
        state === 'success'
          ? 'border-green-500 bg-green-50 dark:bg-green-950'
          : 'border-red-500 bg-red-50 dark:bg-red-950'
      }`}
    >
      {state === 'success' ? (
        <>
          <CheckCircle className="mx-auto h-12 w-12 text-green-500" />
          <div>
            <p className="text-lg font-bold text-green-800 dark:text-green-200">Check-In Successful</p>
            {result && (
              <div className="mt-2 space-y-0.5">
                <p className="text-sm font-medium text-green-700 dark:text-green-300">
                  {result.purchaserName}
                </p>
                <p className="text-sm text-green-600 dark:text-green-400">{result.ticketTypeName}</p>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <XCircle className="mx-auto h-12 w-12 text-red-500" />
          <div>
            <p className="text-lg font-bold text-red-800 dark:text-red-200">
              We couldn&apos;t check in this ticket
            </p>
            <p className="mt-2 text-sm text-red-600 dark:text-red-400">
              {errorMsg ?? withErrorCode('We could not check in this ticket.', 'ticketing/check-in')}
            </p>
          </div>
        </>
      )}

      <Button
        type="button"
        variant="outline"
        onClick={onReset}
        className="w-full"
      >
        Scan Another
      </Button>
    </div>
  )
}
